<div class="dialog-header-container">
    <h2 class="mar-b-5 pd-t-5px" mat-dialog-title ><a class="title-size" (click)="viewMeeting(meetingInfoData.meetingData)">{{hideUseTemplate == true ? meetingInfoData.meetingData.meetingTitle : meetingInfoData.selTemplate}}</a></h2>
    <div class="d-flex justify-content-end align-items-center">
        <div *ngIf = "!hideUseTemplate == true" [ngStyle]="{'margin':'10px'}">
            <button mat-raised-button actions class="button-container primary" [ngStyle]="{'color':'#fff'}" (click)="loadTemplateData(meetingInfoData)">
                USE TEMPLATE
            </button>
        </div>
        <button mat-icon-button class="template_btn" mat-dialog-close aria-label="Example icon-button with heart icon" >
            <mat-icon class="close-icon" mat-dialog-close>
                close
            </mat-icon>
        </button>
    </div>
</div>
<mat-divider class = "mat-divider"></mat-divider>
<mat-dialog-content class="dialog-without-actions">
    <div class="content-container">
    
        <div class="sub-header-container" *ngIf = "hide == false">
            <div class="left-sub-header-container d-flex">
                <!-- <span><mat-icon [ngStyle]="{'margin-right':'10px'}">today</mat-icon></span> -->
                <h3 class="dlog-date-container m-0">
                    {{meetingInfoData.meetingData.meetingDateFullFormat == undefined?fullDate:meetingInfoData.meetingData.meetingDateFullFormat}} at {{meetingInfoData.meetingData.meetingStartTime}} PM for {{meetingInfoData.meetingData.duration}} Minutes
                </h3>
            </div>
            <div class="right-sub-header-container">
               <!-- <button mat-raised-button class="start"><p class="vert-icon-p-tag">START</p></button> -->
            </div>
        </div>
        <div>
            <ul class="un-order-list-container">
                <ng-container *ngFor = "let attendeeName of meetingInfoData.meetingData.attendeeList">                    
                    <app-participant-view-chip [flagData] = "meetingInfoData.meetingData.meetingStartFlag" [participantName] = "attendeeName" [participantJsonData] = "meetingInfoData.meetingData"></app-participant-view-chip>
                </ng-container>
            </ul>
        </div>
        <mat-divider></mat-divider>
        <div class="task-details">
            <cdk-accordion class="example-accordion" multi = "true">
                <cdk-accordion-item 
             
                  expanded = "true"
                  *ngFor="let item of meetingInfoData.meetingData.agendaList; let index = index;"
                  #accordionItem="cdkAccordionItem"
                  class="example-accordion-item overallagenda_div"
                 
                  tabindex="0"
                  [attr.id]="'accordion-header-' + index"
                  [attr.aria-expanded]="accordionItem.expanded"
                  [attr.aria-controls]="'accordion-body-' + index"
                  >
                  <div class="d-flex">
                    <!-- <p>One</p> -->
                    <div class="d-flex col-md-11">
                        <!-- <button mat-icon-button class="example-accordion-item-description" (click)="accordionItem.toggle()"> -->
                            <mat-icon (click)="accordionItem.toggle()">{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                        <!-- </button> -->
                        <div>
                            <h3 class="margin-0 body-font-size f-weight agendaTitle">{{item.agendaTitle==emptyAgenda ? "":item.agendaTitle }}</h3>
                        </div>
                    </div>
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'"
                    >
                    <div [ngStyle]="{'margin-left':'20px', 'margin-top':'5px', 'margin-bottom':'5px'}">
                        <mat-list>
                            <mat-list-item class="height-0">
                                <div class="d-flex" [ngStyle]="{'width':'100%', 'margin-bottom':'5px'}" *ngFor="let agendaItems of item.minutesList">
                                
                                    <div class="d-flex col-md-11" *ngIf = "agendaItems.noteId != null">
                                        <div>        
                                            <button class="global-icn-bttn-containers mat-margin-3px" mat-mini-fab tooltip = "Notes" triggers = "hover"><mat-icon class ="global-icn-size notes">notes</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size"  [innerHTML]="agendaItems.noteDescription"></h4>
                                        </div>
                                    </div>
                                    <div class="d-flex col-md-11" *ngIf = "agendaItems.taskId != null">
                                        <div>        
                                            <button class="mat-margin-3px global-icn-bttn-containers" mat-mini-fab tooltip = "Task" triggers = "hover"><mat-icon class = "global-icn-size assignment">assignment</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size" [innerHTML]="agendaItems.taskTitle"></h4>
                                        </div>
                                    </div>
                                    <div class="d-flex col-md-11" *ngIf = "agendaItems.decisionId != null">
                                        <div>        
                                            <button  class="mat-margin-3px global-icn-bttn-containers hide" mat-mini-fab tooltip = "Decision" triggers = "hover"><mat-icon class = "global-icn-size decision">thumb_up</mat-icon></button>
                                        </div>
                                        <div>        
                                            <h4 class="acc-content body-font-size" [innerHTML]="agendaItems.noteDescription"></h4>
                                        </div>
                                    </div>
                            </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <div *ngIf = "item.minutesList.length == 0">
                        <h3 class="margin-0" [ngStyle]="{'margin-left':'45px !important'}"></h3>
                    </div>
                  </div>
                </cdk-accordion-item>
            </cdk-accordion>
        </div>

    </div>
</mat-dialog-content>

